/* eslint-disable no-restricted-imports */
/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React, { useMemo } from "react";
import { Link } from "react-router-dom";
import Dropdown from "react-bootstrap/Dropdown";
import { useSelector } from "react-redux";
import objectPath from "object-path";
import { useHtmlClassService } from "../../../_core/MetronicLayout";
import { toAbsoluteUrl } from "../../../../_helpers";
import { DropdownTopbarItemToggler } from "../../../../_partials/dropdowns";
import { getTokenClaims } from "../../../../../app/services/auth.service";
import PersonIcon from "@mui/icons-material/Person";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import LogoutIcon from "@mui/icons-material/Logout";
import { Typography } from "@mui/material";
import Grid from "@mui/material/Grid";
import { useHistory, useParams } from "react-router-dom";
import { Button } from "@mui/material";
import KeyIcon from "@mui/icons-material/Key";

export function UserProfileDropdown() {
  const { user } = useSelector((state) => state.auth);
  const uiService = useHtmlClassService();
  const layoutProps = useMemo(() => {
    return {
      light:
        objectPath.get(uiService.config, "extras.user.dropdown.style") ===
        "light",
    };
  }, [uiService]);

  const history = useHistory();
  const openProfile = () => {
    history.push("/profile");
  };
  return (
    <Dropdown drop="down" alignRight>
      <Dropdown.Toggle
        as={DropdownTopbarItemToggler}
        id="dropdown-toggle-user-profile"
      >
        <div
          className={
            "btn btn-icon w-auto btn-clean d-flex align-items-center btn-lg px-2 divDrop1 "
          }
        >
          {/*<span className="symbol symbol-35 symbol-light-success">
            <span
              style={{ width: "70px" }}
              className="symbol-label font-size-h5 font-weight-bold"
        >*/}
          <PersonIcon className="Icons personIcon" />
          {/* </span>
      </span>*/}
        </div>
      </Dropdown.Toggle>
      <Dropdown.Menu
        className="p-0 m-0 dropdown-menu-right dropdown-menu-anim dropdown-menu-top-unround dropdown-menu-xl divDrop"
        style={{ zIndex: -1 }}
      >
        <>
          {!layoutProps.light && (
            <div
              className="d-flex align-items-center justify-content-between flex-wrap p-6 bgi-size-cover bgi-no-repeat rounded-top"
              // style={{
              //   background: `url(${toAbsoluteUrl("/media/bg/bg-8.jpg")})`,
              // }}
            >
              <Grid container spacing={2} className="mTop5">
                <Grid xs={3}>
                  <AccountCircleIcon className="iconProfile iconProfileBorder colorDefaultFont marginLeft-15" />
                </Grid>
                <Grid xs={7} className="colorUserProfile textFont14">
                  <b>{getTokenClaims()?.fullname}</b>
                  <div className="colorFFF textFont14 colorFFF mTop5 ">
                    {" "}
                    {getTokenClaims()?.username}{" "}
                  </div>
                </Grid>

                <Grid item xs={2}></Grid>

                {/* <Grid item xs={3}></Grid> */}
                {/* <Grid item xs={8}>
                  <b className=" colorGreen ">{getTokenClaims()?.fullname} </b>
                </Grid> */}
              </Grid>
            </div>
          )}
        </>

        <div className="navi navi-spacer-x-0 ">
          <div className="navi-separator "></div>

          <div
            className="navi-footer  px-8 py-5"
            style={{ marginRight: "10px" }}
          >
            <Link
              to="/profile"
              className=" font-weight-bold colorFFF textFont11 "
            >
              <KeyIcon style={{ marginLeft: "10px" }} />
              تغییر رمز ورود
            </Link>
          </div>
        </div>

        <div className="navi navi-spacer-x-0 ">
          <div className="navi-separator"></div>

          <div
            className="navi-footer  px-8 py-5"
            onClick={handelToken}
            style={{ marginRight: "10px" }}
          >
            <Link
              to="/login"
              className=" font-weight-bold colorFFF textFont11 "
            >
              <LogoutIcon style={{ marginLeft: "10px" }} />
              خروج از حساب کاربری
            </Link>
          </div>
        </div>
      </Dropdown.Menu>
    </Dropdown>
  );
}

const TOKEN_KEY = "tokenOpration";
const handelToken = () => {
  localStorage.removeItem(TOKEN_KEY);
  localStorage.setItem("setActivePage", "Wellcome");
};
